module.exports = __webpack_public_path__ + "static/media/0f7e7aad-e1dd-4ca5-b86a-7d75ac28831f.74840125.webp";